// @flow

import _ from "lodash";
import Config from "../constants/Config.js";

import { type ImageType } from "../types";
import addACFData from "./addACFData";

export const getExcerpt = (post: any): any => {
    return _.get(post, "acf.meta[0].excerpt");
};

export const getFeaturedImage = (
    page: any,
    giveFallBack: boolean = true,
    profileFallback: boolean = false
): ?ImageType => {
    const featured_image = _.get(
        page,
        ["acf", "meta", "0", "featured_image"],
        null
    );
    if (featured_image) {
        return featured_image;
    } else {
        return giveFallBack
            ? {
                  url: profileFallback
                      ? Config.fallbackProfileImage
                      : Config.fallbackFeaturedImage,
                  width: 1200,
                  height: 800,
                  alt: "",
              }
            : null;
    }
};

export const getPageType = (page: any): ImageType => {
    const postType = _.get(page, ["post_type"], null);
    const pageTemplate = _.get(page, ["page_template"], null);
    if (postType !== "page") {
        return postType;
    } else {
        return pageTemplate
            .replace("templates/", "")
            .replace("-page.php", "")
            .replace(".php", "");
    }
};

/** Takes the registered post type name and maps it to the slug
 * used to access the post type in the REST api */
export const getPostTypeAPIName = (postType: string): string => {
    const postTypeAPISlugMap = {
        page: "pages",
        news: "news",
        club: "clubs",
        event: "events",
        profiles: "profiles",
        product: "products",
    };
    return postTypeAPISlugMap[postType];
};

/** Returns the category slug for each post type slug (Use `getPostTypeAPIName()` to get API safe slug name) */
export const getCategoryForPostType = (postType: string): string => {
    const categoriesMap = {
        pages: "page-category",
        clubs: "club_category",
        events: "event_category",
        news: "news-category",
        profiles: "profiles-category",
        "media-releases": "mediareleases-category",
        jobs: "jobs-category",
        products: "category",
    };
    return categoriesMap[postType];
};

export const getEyebrow = (post: any): string => {
    // uses am-general.php PostType name + "s"
    switch (post.post_type || post.type) {
        case "news":
            return "News";
        case "researchareas":
            return "Research Area";
        case "researchcentres":
            return "Research Centre";
        case "researchprojects":
            return "Research Project";
        case "researchstudies":
            return "Research Study";
        case "profiles":
            return "Profile";
        case "mediareleases":
            return "Media Release";
        case "jobs":
            return "Jobs";
        default:
            let decorated = addACFData(post);
            if (decorated.top_ancestor) {
                return decorated.top_ancestor.title;
            }
            return post.title || "Page";
    }
};

const post = {
    getExcerpt,
    getFeaturedImage,
    getCategoryForPostType,
    getPostTypeAPIName,
    getEyebrow,
    getPageType,
};

export default post;
